import { featureFlagClient } from '@trello/feature-flag-client';

const cachedFlagValues: {
  [key: string]: boolean;
} = {};
// export for mocking in tests
export const cachedFlagValue = (key: string, defaultValue: boolean) => {
  if (cachedFlagValues[key] === undefined) {
    cachedFlagValues[key] = featureFlagClient.get(key, defaultValue);
  }
  return cachedFlagValues[key];
};
